import { HttpStatusCode } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/common/global-constants';
import { GlobalMethods } from 'src/app/common/global-methods';
import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';
import { RegisterUserVm } from 'src/app/services/property-matrix/models';
import { AuthenticateService } from 'src/app/services/property-matrix/services';

@Component({
  selector: 'app-conveyancer-register-details',
  templateUrl: './conveyancer-register-details.component.html',
  styleUrls: ['./conveyancer-register-details.component.scss', '../../../../../css/2-modules/_forms.scss']
})
export class ConveyancerRegisterDetailsComponent implements OnInit {

  loading: boolean = false;
  emailPattern = GlobalConstants.emailPattern;
  passwordPattern = GlobalConstants.passwordPattern;

  form: RegisterUserVm = {
    personalDetails: {
      alternativeNumber: '',
      emailAddress: '',
      emailConfirmed: false,
      id_Number: '',
      name: '',
      phoneNumber: '',
      surname: '',
      rsa_Resident: false,
      phoneNumberConfirmed: false,
      landline: '',
      title: '',
      confirmEmail: '',
      confirmPhoneNumber: ''
    },
    loginDetails: {
      email: '',
      password: '',
      passwordConfirm: '',
    }
  }

  constructor(private router: Router, private authService: AuthenticateService, private sharedService: PropertyMatrixSharedService) { }

  register() {
    this.loading = true;
    this.authService.apiV1AuthenticateRegisterConveyancerPost$Response({ body: this.form })
      .subscribe({
        next: (result) => {
          if (result.status == HttpStatusCode.Conflict) {
            GlobalMethods.tinyErrorAlert('Error', 'User already exists');
            return;
          }
          GlobalMethods.tinySuccessAlert('Welcome', 'Please login. After signing in, you will be redirected the conveyancer info page.').then(result => {
            GlobalMethods.navigateToLoginWithRouteStored('originalUrl', '/conveyancer-registration', this.router)
          });
          this.loading = false;
        }
        , error: (error) => {
          GlobalMethods.tinyErrorAlert('Error', 'User already exists')
          this.loading = false;
        }
      })
  }

  ngOnInit(): void {
    const user = this.sharedService.getUserModel();
    if (user) {
      this.router.navigateByUrl('/conveyancer-registration')
    }
  }
}
